import { sendGet, sendPost, sendDelete } from './../helpers/axios';

export const apiGetListMailTemplate = (params) => sendGet('/api/mail-template/get-list', params);
export const apiGetDetailMailTemplate = (params) => sendGet('/api/mail-template/get-detail', params);
export const apiSaveMailTemplate = (params) => sendPost('/api/mail-template/save', params);
export const apiDeleteMailTemplate = (params) => sendDelete('/api/mail-template/delete', params);
export const apiGetMailPlaceholders = () => sendGet('/api/mail-template/placeholders');
export const apiPreviewMail = (params) => sendPost('/api/mail-template/preview', params);

export const apiGetMailLogs = (applyId) => sendGet(`/api/candidate/apply/${applyId}/mail-logs`);
export const apiGetMailRecipient = (applyId) => sendGet(`/api/candidate/apply/${applyId}/mail-recipient`);
export const apiSendCandidateMail = (applyId, params) => sendPost(`/api/candidate/apply/${applyId}/send-mail`, params);
export const apiResendCandidateMail = (id) => sendPost(`/api/candidate/apply/mail-logs/${id}/resend`);
